/* eslint-disable */
import * as yup from 'yup';

const phoneRegExp = /^(\+\d{1,3}[- ]?)?\d{10}$/;
const bankAccountExp = /^[a-zA-Z0-9]+$/;
const taxCode12RegExp = /^[0-9]{12}$/;

export const contactFormSchema = yup.object().shape({
  address: yup.string(),
  content: yup.string().required('Bạn chưa nhập nội dung'),
  email: yup.string(),
  name: yup.string().required('Bạn chưa nhập họ tên'),
  phone: yup.string().matches(/(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/, 'Số điện thoại không hợp lệ'),
  attachment: yup.string(),
});

export const aiProfileSchema = yup.object().shape({
  agentName: yup
    .string()
    .required('This field is required')
    .matches(
      /^[a-zA-Z0-9\s\u00C0-\u1EF9\u0102\u0110\u0128\u0168\u01A0\u01AF\u1EA0-\u1EF9]*$/,
      'Invalid name format. Please use letters only.'
    ),
  description: yup.string().max(200, 'Maximum 200 characters'),
  instruction: yup.string().nullable(),
  language: yup.object().required('This field is required').required('This field is required'),
  avatar: yup.string().required('Avatar is required'),
  mainColor: yup.string().required('Please choose color'),
  bgColorFirst: yup.string().required('Please choose color'),
  bgColorSecond: yup.string().required('Please choose color'),
  // mainColor: yup.string().required('Please choose color'),
});

export const agentCustomizationSchema = yup.object().shape({
  // only accept numbers, spaces, and alphabets
  name: yup
    .string()
    .required('This field is required')
    .matches(
      /^[a-zA-Z0-9\s\u00C0-\u1EF9\u0102\u0110\u0128\u0168\u01A0\u01AF\u1EA0-\u1EF9]*$/,
      'Invalid name format. Please use letters only.'
    ),
  avatar: yup.string().required('Avatar is required'),
  shortDescription: yup.string().max(200, 'Maximum 200 characters'),
  anonymousWelcomeMsg: yup.string(),
  userWelcomeMsg: yup.string().max(500, 'Maximum 500 characters'),
  userOnboardMsg: yup.string().max(500, 'Maximum 500 characters'),
  bothWelcomeMsg: yup.string().max(500, 'Maximum 500 characters'),
  bothOnboardMsg: yup.string().max(500, 'Maximum 500 characters'),
  mainColor: yup.string().required('Please choose color'),
  bgColorFirst: yup.string().required('Please choose color'),
  bgColorSecond: yup.string().required('Please choose color'),
});

export const customerTagSchema = yup.object().shape({
  name: yup
    .string()
    .required('Please input information')
    .matches(/^[a-zA-Z0-9]+$/, 'Only letters and numbers are allowed'),
});

export const createUserSchema = yup.object().shape({
  name: yup.string().required('Please input information'),
  email: yup.string().email('Email is invalid').required('Please input information'),
  phone: yup
    .string()
    .matches(/(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/, 'Invalid phone number')
    .required('Please input information'),
});

export const crawLinkSchema = yup.object().shape({
  link: yup
    .string()
    .required('Please input information')
    .matches(/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?(\?.*)?$/, 'Must be a valid link format'),
  type: yup.number().required('Please input information'),
});

export const testSMSSchema = yup.object().shape({
  phone: yup
    .string()
    .matches(/^(0[1|3|5|7|8|9])[0-9]{8}$/, 'Invalid phone number')
    .required('Please input information'),
});

export const testMailSchema = yup.object().shape({
  mail: yup.string().email('Email is invalid').required('Please input information'),
});

export const eventFormSchema = yup.object().shape({
  idCardNumber: yup
    .string()
    .required('Thông tin này là bắt buộc')
    .matches(/^[0-9]{12}$/, 'Số CCCD phải là 12 ký tự số'),
});

export const regisFormSchema = yup.object().shape({
  fullname: yup.string().required('Trường này là bắt buộc'),
  dob: yup.string().required('Trường này là bắt buộc'),
  phoneNumber: yup.string().required('Trường này là bắt buộc').nullable().matches(phoneRegExp, 'Số điện thoại không đúng định dạng'),
  idCardNumber: yup.string().required('Trường này là bắt buộc')
    .matches(/^[0-9]{12}$/, 'Số CCCD phải là 12 ký tự số'),
  idCardIssuedAt: yup.string().required('Trường này là bắt buộc'),
  idCardIssuedBy: yup.string().required('Trường này là bắt buộc'),
  idCardFrontImage: yup.mixed<File>().required('Trường này là bắt buộc'),
  idCardBackImage: yup.mixed<File>().required('Trường này là bắt buộc'),
  taxCode: yup.string().required('Trường này là bắt buộc')
    .test('taxCode', 'Mã số thuế phải là 12 ký tự số', (value) => {
      if (value) {
        if (value === 'Chưa có mã số thuế') {
          return true;
        }
        return !!value.match(taxCode12RegExp);
      }
      return false;
    }),
  permanentAddress: yup.string().required('Trường này là bắt buộc'),
  contractType: yup.object().shape({}).default(undefined).required('Trường này là bắt buộc'),
  socialInsuranceNumber: yup.string().nullable(),
  socialInsuranceJoinDate: yup.string().nullable(),
  socialInsuranceImage: yup.mixed<File>(),
  bankAccounts: yup.array().of(
    yup.object().shape({
      bankAccount: yup.string().required('Trường này là bắt buộc').matches(bankAccountExp, 'Số tài khoản không được chứa khoảng trắng hoặc kí tự đặc biệt'),
      bankOwner: yup.string().required('Trường này là bắt buộc'),
      bankCode: yup.string(),
      bankName: yup.object().shape({}).nullable().default(null).required('Trường này là bắt buộc'),
      bankBranch: yup.object().shape({}).nullable().default(null).when('bankName', {
        is: (f: OptionType) => f?.value && f.value.toString().toLowerCase().includes('agribank'),
        then: yup.object().shape({}).nullable().default(null).required('Trường này là bắt buộc'),
        otherwise: yup.object().shape({}).nullable().default(null).notRequired(),
      }),
      city: yup.object().shape({}).nullable().default(null)
        .when('bankName', {
          is: (f: OptionType) => f?.value && f.value.toString().toLowerCase().includes('agribank'),
          then: yup.object().shape({}).nullable().default(null).required('Trường này là bắt buộc'),
          otherwise: yup.object().shape({}).nullable().default(null).notRequired(),
        }),
      isDefault: yup.boolean()
    })
  ).min(1, 'Cần ít nhất 1 tài khoản ngân hàng').test({
    name: 'check at least one default account',
    message: 'Cần có một tài khoản mặc định',
    test: (accounts) => {
      if (accounts && accounts.length > 0) {
        if (accounts.every((acc) => !!acc.bankName)) {
          return accounts.some((acc) => acc.isDefault);
        }
      }
      return true;
    }
  }),
  isAgree: yup.boolean().oneOf([true], 'Bạn phải đồng ý điều khoản và điều kiện để tiếp tục'),
});

export const regisFormSchemaStep2 = yup.object().shape({
  bankAccounts: yup.array().of(
    yup.object().shape({
      bankAccount: yup.string().required('Trường này là bắt buộc').matches(bankAccountExp, 'Số tài khoản không được chứa khoảng trắng hoặc kí tự đặc biệt'),
      bankOwner: yup.string().required('Trường này là bắt buộc'),
      bankCode: yup.string(),
      bankName: yup.object().shape({}).nullable().default(null).required('Trường này là bắt buộc'),
      bankBranch: yup.object().shape({}).nullable().default(null)
        .when('bankName', {
          is: (f: OptionType) => f?.value && f.value.toString().toLowerCase().includes('agribank'),
          then: yup.object().shape({}).nullable().default(null).required('Trường này là bắt buộc'),
          otherwise: yup.object().shape({}).nullable().default(null).notRequired(),
        }),
      city: yup.object().shape({}).nullable().default(null)
        .when('bankName', {
          is: (f: OptionType) => f?.value && f.value.toString().toLowerCase().includes('agribank'),
          then: yup.object().shape({}).nullable().default(null).required('Trường này là bắt buộc'),
          otherwise: yup.object().shape({}).nullable().default(null).notRequired(),
        }),
      isDefault: yup.boolean()
    })
  ).min(1, 'Cần ít nhất 1 tài khoản ngân hàng').test({
    name: 'check at least one default account',
    message: 'Cần có một tài khoản mặc định',
    test: (accounts) => {
      if (accounts && accounts.length > 0) {
        if (accounts.every((acc) => !!acc.bankName)) {
          return accounts.some((acc) => acc.isDefault);
        }
      }
      return true;
    }
  }),
});
